<template>
<div>
    <div v-if="editing">
        <div class="mb-3">
            <label>{{'File name' | translate}}</label>
            <input type="text" class="form-control" v-model="component.text">
        </div>
        <FileUpload
            :file-path="component.file"
            @uploadCompleted="storeFile"
            @fileDeleted="deleteFile"
            context="component.file"
            :accepted-type="acceptedType"
        ></FileUpload>
        <div v-if="isMp3">
            <div class="form-check mt-3">
                <input class="form-check-input" type="checkbox" value="" id="c1" v-model="download">
                <label class="form-check-label" for="c1">
                    {{'Make this audio content downloadable' | translate}}
                </label>
            </div>
        </div>
        <div v-if="isPdf" class="mt-3">
            <div class="form-check" v-if="!noDownload">
                <input class="form-check-input" type="checkbox" value="" id="c1" v-model="watermark">
                <label class="form-check-label" for="c1">
                    {{'Watermark pdf with student\'s email' | translate}}
                </label>
            </div>
            <div class="form-check" v-if="!watermark">
                <input class="form-check-input" type="checkbox" value="" id="c2" v-model="noDownload">
                <label class="form-check-label" for="c2">
                    {{'No download' | translate}}. {{'Display inside the lecture' | translate}}
                </label>
            </div>
        </div>
    </div>
    <div v-else-if="fileUpladed">
        <a :href="fileUrl" target="_blank">{{fileName}}</a>
    </div>
</div>
</template>

<script>
import route from './../../routes.js'
import FileUpload from './../FileUpload'
import _ from 'lodash'

export default {
    components: {
        FileUpload,
    },
    props: [
        'component',
        'editing',
    ],
    computed: {
        fileName() {
            const name = _.get(this.component, 'text', null)
            if (name) {
                return name
            }
            return this.component.file
        },
        fileUrl() {
            return `https://skyier-bucket.s3.eu-west-1.amazonaws.com/${this.component.file}`
        },
        fileUpladed() {
            return _.get(this.component, 'file', false)
        },
        acceptedType() {
            return this.component.type
        },
        isMp3() {
            return this.component.type === 'audio'
        },
        isPdf() {
            const file = _.get(this.component, 'file', null)
            if (file) {
                return file.split('.').pop() === 'pdf'
            }
            return false
        },
        download: {
            get() {
                return _.get(this.component, 'data.download')
            },
            set(value) {
                this.component.data = {...this.component.data, download: value}
            },
        },
        watermark: {
            get() {
                return _.get(this.component, 'data.watermark')
            },
            set(value) {
                this.component.data = {...this.component.data, watermark: value}
            },
        },
        noDownload: {
            get() {
                return _.get(this.component, 'data.no_download')
            },
            set(value) {
                this.component.data = {...this.component.data, no_download: value}
            },
        },
    },
    methods: {
        deleteFile() {
            this.component.file = null
            this.$emit('fileDeleted')
        },
        storeFile(filePath) {
            this.$set(this.component, 'file', filePath)
            this.$emit('fileUploaded')
        },
        img(url){
            if (url) return route.image(url)
            return false
        },
    },
}
</script>

<style>
</style>